import React, { Fragment, useCallback, useEffect, useState } from "react";
import {
  Table,
  TableHeader,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  NoDataFound,
} from "../../../../components/table/tableComponent";
import DefaultButton from "../../../../components/buttons/defaultButton";
import TableSkeleton from "../../../../components/skeleton/tableSkeleton";

import { FiEdit2 } from "react-icons/fi";
import { BsEye } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { getPackageHistoryList } from "../../../../../services/workspace/history.service";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import moment from "moment";
import { MdOutlineWorkHistory } from "react-icons/md";
import DefaultBadge from "../../../../components/badge/defaultBadge";

const PackageHistoryTable = () => {
  const headers = ["Package Name", "Cost", "Purchase At", "Status", "Action"];

  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [fetchMore, setfetchMore] = useState(false);
  const [tableData, setTableData] = useState();
  const [totalData, setTotalData] = useState();
  const { limit } = useSelector((state) => state.global);

  const handleViewClick = (item) => {
    navigate(`/configuration/manage-history/package-view/${item?.uuid}`, {
      state: { item },
    });
  };

  const fetchData = useCallback(() => {
    if (currentPage == 0 || !fetchMore) {
      setLoading(true);
    }
    getPackageHistoryList({ search: "", page: currentPage, limit })
      .then((response) => {
        setTableData((prevTableData) => {
          const combinedData =
            currentPage === 1
              ? [...response.data]
              : [...prevTableData, ...response.data];
          return combinedData;
        });
        setTotalData(response.total);
      })
      .catch((error) => {
        toast.error("Failed to fetch reminder data!");
        console.error("Error fetching data: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [currentPage, limit]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="flex flex-col gap-2">
      <Fragment>
        <Table className="shadow-md">
          <TableHeader>
            <TableRow>
              {headers.map((header, index) => (
                <TableHead key={index}>{header}</TableHead>
              ))}
            </TableRow>
          </TableHeader>
          <TableBody>
            {loading ? (
              <TableSkeleton colSpan={headers.length} />
            ) : (
              <>
                {tableData?.length > 0 ? (
                  tableData?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{item?.package?.name}</TableCell>
                      <TableCell>{item?.amount}</TableCell>

                      <TableCell>
                        {moment(item?.created_at).format(
                          "DD MMM YYYY, hh:mm A"
                        )}
                      </TableCell>
                      <TableCell>
                        <DefaultBadge custom={item?.status === 0 ? "Active" : "Expired"} />
                      </TableCell>

                      <TableCell sticky className={"flex items-center gap-2"}>
                        <DefaultButton
                          variant="iconButton"
                          icon={<BsEye />}
                          tooltip={"View"}
                          onClick={() => handleViewClick(item)}
                        />
                        <DefaultButton
                          variant="iconButton"
                          icon={<MdOutlineWorkHistory />}
                          tooltip={"View Transaction"}
                          onClick={() => {
                            navigate(
                              `/configuration/manage-history/payment-view/${item?.package_history?.uuid}`
                            );
                          }}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <NoDataFound colSpan={headers.length} />
                  </TableRow>
                )}
              </>
            )}
          </TableBody>
        </Table>
      </Fragment>
    </div>
  );
};

export default PackageHistoryTable;
